const LOG_LEVELS = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
};

const IS_DEV = process.env.NODE_ENV === 'development';

// Levels that should print to the browser console in production.
// Debug and info are suppressed to prevent sensitive data leaking.
const CONSOLE_LEVELS_PROD = new Set(['warn', 'error']);

class Logger {
  constructor() {
    this.logs = [];
    this.maxLogs = 1000; // Keep last 1000 logs in memory
  }

  _log(level, message, data = null) {
    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      level,
      message,
      data
    };

    // Store log in memory (always — useful for diagnostics via window.logger)
    this.logs.push(logEntry);
    if (this.logs.length > this.maxLogs) {
      this.logs.shift();
    }

    // Only emit to console if level is allowed for current environment
    if (IS_DEV || CONSOLE_LEVELS_PROD.has(level)) {
      const logData = data ? { ...logEntry, data } : logEntry;
      console[level](JSON.stringify(logData, null, 2));
    }
    
    // Make logger accessible in development
    if (IS_DEV) {
      window.appLogs = window.appLogs || [];
      window.appLogs.push(logEntry);
      window.logger = this;
    }
  }

  debug(message, data = null) {
    this._log(LOG_LEVELS.DEBUG, message, data);
  }

  info(message, data = null) {
    this._log(LOG_LEVELS.INFO, message, data);
  }

  warn(message, data = null) {
    this._log(LOG_LEVELS.WARN, message, data);
  }

  error(message, data = null) {
    this._log(LOG_LEVELS.ERROR, message, data);
  }

  getLogs(level = null, limit = 100) {
    let filteredLogs = this.logs;
    if (level) {
      filteredLogs = filteredLogs.filter(log => log.level === level);
    }
    return filteredLogs.slice(-limit);
  }

  clearLogs() {
    this.logs = [];
  }
}

export const logger = new Logger();
export default logger;
